import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../../app.bootstrap';
import {getAppTracer} from '../../../../app.tracer';
import {IRedirectToStoreStore, RedirectToStoreStore} from './store.stores';

const trace = getAppTracer('store.loader');

export async function storeRouteLoader(_args: LoaderFunctionArgs): Promise<IRedirectToStoreStore> {
    trace.info('Starting');
    const rootStore = getRootStore();

    await rootStore.initRootServicesCompleted;

    const store = new RedirectToStoreStore();

    trace.info('Completed successfully');
    return store;
}
